<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.physicalExams', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mPhysical.reference }}
                        </h3>
                    </div>

                    <div class="list-group list-group-flush">
                        <div class="list-group-item">
                            {{ $tc('message.references', 1) }}:

                            <span class="font-weight-bold">
                                {{ mPhysical.reference }}
                            </span>
                        </div>

                        <div class="list-group-item">
                            {{ $t('message.description') }}:

                            <div class="font-weight-bold">
                                {{ mPhysical.description }}
                            </div>
                        </div>
                    </div>

                    <div class="card-footer text-right">
                        <b-button v-b-modal.delete-modal variant="danger">
                            {{ $t('message.delete') }}
                        </b-button>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.physicalExams', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mPhysical.reference }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deletePhysicalExam">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "PhysicalExam",

        computed: {
            ...mapGetters(["physicalExam"]),

            mPhysical: function() {
                return this.physicalExam;
            }
        },

        data() {
            return {
                physical_id: this.$route.params.physical
            }
        },

        methods: {
            getPhysicalExam() {
                let args = {
                    physical: this.physical_id
                };

                this.$store.dispatch("getPhysicalExam", { args });
            },

            deletePhysicalExam() {
                let self = this;
                let args = {
                    physical: this.physical_id
                };

                let successMessage = this.$i18n.t('message.physicalExamDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePhysicalExam', { args, index: self.physical_id, successMessage, errorMessages });
            }
        },

        mounted() {
            this.getPhysicalExam();
        }
    }
</script>

<style scoped>

</style>